"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledCB = styled_components_1.default(antd_1.Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n"], ["\n  .ant-checkbox-inner {\n    width: 20px;\n    height: 20px;\n    border-radius: 3px;\n    border: 2px solid #2362a2;\n    outline: none;\n  }\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: none;\n    outline: none;\n  }\n"])));
var StyledCheckBox = function (_a) {
    var onClick = _a.onClick, onChange = _a.onChange, checked = _a.checked, id = _a.id;
    return react_1.default.createElement(StyledCB, { onClick: function (e) { return onClick && onClick(e); }, onChange: function (e) { return onChange && onChange(e); }, checked: checked, type: "checkbox", id: id });
};
StyledCheckBox.defaultProps = {
    onClick: undefined,
    onChange: undefined,
    checked: undefined,
    id: undefined,
};
exports.default = StyledCheckBox;
var templateObject_1;
